import { render, staticRenderFns } from "./DigitalPersonal.vue?vue&type=template&id=f9d31b8e&scoped=true&"
import script from "./DigitalPersonal.vue?vue&type=script&lang=js&"
export * from "./DigitalPersonal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d31b8e",
  null
  
)

export default component.exports